<template>
  <div class="part list-skeleton animated fadeIn">
    <div class="line" v-for="(l, i) in listArray" :key="i">
      <div class="avatar">
        <span class="figure"></span>
      </div>
      <div class="paragraph">
        <span class="figure" v-for="(p, i) in paragraphsArray" :key="i"></span>
      </div>
      <div class="actions">
        <span class="figure" v-for="(a, i) in actionsArray" :key="i"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list-skeleton',
  props: {
    list: {
      type: Number,
      default: 6,
    },
    paragraphs: {
      type: Number,
      default: 2,
    },
    actions: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      listArray: new Array(this.list),
      paragraphsArray: new Array(this.paragraphs),
      actionsArray: new Array(this.actions),
    }
  },
}
</script>

<style lang="scss" scoped>
@keyframes skeleton {
  0% {
    background-position: 100% 50%;
  }
  to {
    background-position: 0 50%;
  }
}

.list-skeleton {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;

  .figure {
    // background: #f2f2f2;
    background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
    background-size: 400% 100%;
    animation: skeleton 1.4s ease infinite;
    border-radius: 4px;
  }

  .line {
    width: 100%;
    display: inline-flex;
    gap: 1rem;
    border-bottom: 1px solid #e8e8e8;
    padding: 1rem 0;
    .avatar {
      flex: 0;
      .figure {
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
      }
    }
    .paragraph {
      flex: 1;
      flex-grow: 1;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;
      .figure {
        height: 1rem;
      }
    }

    .actions {
      flex: 0;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      border-left: 1px solid #ececec;
      padding-left: 1rem;
      .figure {
        background: #ccc;
        border-radius: 100%;
        width: 1rem;
        height: 1rem;
      }
    }
  }
}
</style>
